export default class UserAuthModel {
  public emailAddress: string = ''
  public password: string = ''

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
